import { FieldDescription, FieldError, FieldLabel, fieldIds, fieldInputClass } from './shared';
import type { FieldProps } from './FieldProps';

export function NumberField({ field, value, error, onChange }: FieldProps) {
  const { inputId, descriptionId, errorId } = fieldIds(field.path);
  const describedBy = [field.schema.description ? descriptionId : null, error ? errorId : null]
    .filter(Boolean)
    .join(' ');

  return (
    <div>
      <FieldLabel htmlFor={inputId} required={field.required}>
        {field.schema.title ?? field.key}
      </FieldLabel>
      <FieldDescription id={descriptionId} text={field.schema.description} />
      <input
        id={inputId}
        type="number"
        className={fieldInputClass}
        // A cleared number field is "no value entered", not zero — an empty
        // string lets ajv's `required` say so honestly instead of a stray 0
        // silently satisfying it.
        value={typeof value === 'number' ? value : ''}
        step={field.schema.type === 'integer' ? 1 : 'any'}
        min={field.schema.minimum}
        max={field.schema.maximum}
        onChange={(event) => {
          const raw = event.target.value;
          onChange(raw === '' ? undefined : Number(raw));
        }}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy || undefined}
      />
      <FieldError id={errorId} message={error} />
    </div>
  );
}
